import { render, staticRenderFns } from "./siderbarItem.vue?vue&type=template&id=524b2f24&scoped=true&"
import script from "./siderbarItem.vue?vue&type=script&lang=js&"
export * from "./siderbarItem.vue?vue&type=script&lang=js&"
import style0 from "./siderbarItem.vue?vue&type=style&index=0&id=524b2f24&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "524b2f24",
  null
  
)

export default component.exports